import { INTEGRATIONS_ACTIONS } from './integrations.types'

/**
 *
 * @param {import('./integrations.types').FeaturebaseSlice['status']} payload
 * @returns {import('./integrations.types').FeaturebaseStatusAction}
 */
export const setFeaturebaseStatusAction = payload => ({ type: INTEGRATIONS_ACTIONS.SET_FEATUREBASE_STATUS, payload })

/**
 *
 * @param {import('../slice.types').SliceError} payload
 * @returns {import('./integrations.types').FeaturebaseErrorsAction}
 */
export const setFeaturebaseErrorsAction = payload => ({ type: INTEGRATIONS_ACTIONS.SET_FEATUREBASE_ERRORS, payload })

/**
 *
 * @param {import('./integrations.types').FeaturebaseSlice['task']} payload
 * @returns {import('./integrations.types').FeaturebaseTaskAction}
 */
export const setFeaturebseTaskAction = payload => ({ type: INTEGRATIONS_ACTIONS.SET_FEATUREBASE_TASK, payload })

/**
 *
 * @param {import('./integrations.types').FeaturebaseSlice['changelog']} payload
 * @returns {import('./integrations.types').AuthTokenAction}
 */
export const setFeaturebaseChangelogAction = payload => ({
  type: INTEGRATIONS_ACTIONS.SET_FEATUREBASE_CHANGELOG,
  payload
})

// /**
//  * @param {import('./integrations.types').FeaturebaseSlice['redirectUri']} payload
//  * @returns {import('./integrations.types').AuthRedirectUriAction}
//  */
// export const setRedirectUriAction = ({ url, external = false }) => ({
//   type: INTEGRATIONS_ACTIONS.SET_REDIRECT_URI,
//   payload: { url, external }
// })

// /**
//  * @returns {import('./integrations.types').AuthClearAction}
//  */
// export const clearAuthErrorsAction = () => ({ type: INTEGRATIONS_ACTIONS.CLEAR_AUTH_ERRORS })

// /**
//  * @returns {import('./integrations.types').AuthClearAction}
//  */
// export const clearAuthTaskAction = () => ({ type: INTEGRATIONS_ACTIONS.CLEAR_AUTH_TASK })

// /**
//  * @returns {import('./integrations.types').AuthClearAction}
//  */
// export const clearAuthTokenAction = () => ({ type: INTEGRATIONS_ACTIONS.CLEAR_AUTH_TOKEN })
